
import { Injectable, Injector } from '@angular/core';
import { Afastamento } from '../models/afastamento.model';
import { Usuario } from '../models/usuario.model';
import { Efemerides, TipoContagem } from '../services/calendar.service';
import { LookupService } from '../services/lookup.service';
import { DaoBaseService } from './dao-base.service';
import { AtividadePausa } from '../models/atividade-pausa.model';
import { TemplateDataset } from '../modules/uteis/templates/template.service';
import { UsuarioCertificado } from '../models/usuario-certificado.model';

@Injectable({
  providedIn: 'root'
})
export class UsuarioDaoService extends DaoBaseService<Usuario> {

  public lookup: LookupService;
  public usuarios:any[] = [];

  constructor(protected injector: Injector) {
    super("Usuario", injector);
    this.lookup = injector.get<LookupService>(LookupService);
    this.inputSearchConfig.searchFields = ["matricula", "nome"];
  }

  public dataset(deeps?: string[]): TemplateDataset[] {
    return this.deepsFilter([
      { field: "nome", label: "Nome" },
      { field: "email", label: "E-mail" },
      { field: "cpf", label: "CPF" },
      { field: "matricula", label: "Matrícula" },
      { field: "apelido", label: "Apelido" },
      { field: "telefone", label: "Telefone" },
      { field: "sexo", label: "Sexo", lookup: this.lookup.SEXO },
      { field: "situacao_funcional", label: "Situação Funcional", lookup: this.lookup.USUARIO_SITUACAO_FUNCIONAL },
      { field: "texto_complementar_plano", label: "Texto complementar do Plano de Trabalho", type: "TEMPLATE"}
    ], deeps);
  }
  
  public calculaDataTempoUnidade(inicio: string, fimOuTempo: string | number, cargaHoraria: number, unidade_id: string, tipo: TipoContagem, pausas?: AtividadePausa[], afastamentos?: Afastamento[]): Promise<Efemerides | undefined> {
    return new Promise<Efemerides | undefined>((resolve, reject) => {
      this.server.post('api/Teste/calculaDataTempoUnidade', { inicio: inicio, fimOuTempo: fimOuTempo, cargaHoraria: cargaHoraria, unidade_id: unidade_id, tipo: tipo, pausas: pausas, afastamentos: afastamentos })
        .subscribe(response => {
          resolve(response.data as Efemerides);
        }, error => {
          console.log("Erro no cálculo das Efemerides pelo servidor!", error);
          resolve(undefined);
        });
    });
  }
 
  public incluirCertificado(descricao: string, certificadoPfxBase64: string, senha: string): Promise<UsuarioCertificado> {
    return new Promise<UsuarioCertificado>((resolve, reject) => {
      this.server.post('api/' + this.collection + '/incluir-certificado', { descricao, certificado: certificadoPfxBase64, senha }).subscribe(response => {
        if(response.error) {
          reject(response.error);
        } else {
          resolve(this.iso8601ToDate(response.certificado) as UsuarioCertificado);
        }
      }, error => reject(error));
    });
  }

  public listarCertificados(): Promise<UsuarioCertificado[]> {
    return new Promise<UsuarioCertificado[]>((resolve, reject) => {
      this.server.post('api/' + this.collection + '/listar-certificados', {}).subscribe(response => {
        if(response.error) {
          reject(response.error);
        } else {
          resolve((response.certificados || []).map((x: any) => this.iso8601ToDate(x) as UsuarioCertificado));
        }
      }, error => reject(error));
    });
  }

  public criarSenhaAssinaturaAvancada(senha: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.server.post('api/' + this.collection + '/criar-senha-assinatura-avancada', { senha }).subscribe(response => {
        if(response.error) {
          reject(response.error);
        } else {
          resolve(response.success);
        }
      }, error => reject(error));
    });
  }

/*
  public usuarioGetAll(){
    return new Promise((resolve, reject) => {
      this.server.post('api/Usuario/usuario-getall', {}).subscribe(response => {
        resolve(response || []);
        console.log(response);
      }, error => reject(error));
    });
  }*/
}
